import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import makeValidationSchema from './SplitGoodsMakeValidationSchema'

const {
  form: {
    field: {
      CngTextField
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  id: null,
  billNo: "",
  parentBillNo: "",
  goodsItemNumber: "",
  containerNumber: "",
  packageQuantity: ""
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled }) {
  const { setValue } = useFormContext()
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const t = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let goodsItemNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.SplitGoods.GOODS_ITEM_NUMBER)
    let containerNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.SplitGoods.CONTAINER_NUMBER)
    let packageQuantity = translate(Namespace.UAE_MPCI, UaeMpciKeys.SplitGoods.PACKAGE_QUANTITY)

    return { goodsItemNumber, containerNumber, packageQuantity }
  }

  return (
    <Grid container spacing={1}>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="goodsItemNumber"
          label={t.goodsItemNumber}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 6 }}
          onChange={(e) => setValue("goodsItemNumber", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="containerNumber"
          label={t.containerNumber}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 17 }}
          onChange={(e) => setValue("containerNumber", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="packageQuantity"
          label={t.packageQuantity}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 8 }}
        />
      </CngGridItem>
    </Grid>
  )
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default FormProperties
